import styled from 'styled-components'

export const Card = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 10.65rem;
  height: 5.75rem;
  background: white;
  padding: 1rem;
  border-radius: 20px;
  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
  @media (max-width: 520px) {
    width: 100%;
    text-align: center;
  }
`
export const Text = styled.article`
  margin-left: 10px;
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
`
